import { FlareDataCommentSchemaPlugin } from '@common/flare-data/plugins/flare-data-comment-schema.plugin';
import { FlareDataUnknownSchemaPlugin } from '@common/flare-data/plugins/flare-data-unknown-schema.plugin';
import { TocSchemaPlugin, TocXmlNodeName } from '@common/flare-data/plugins/toc-schema.plugin';
import { FlareDataXmlSchema } from '@common/flare-data/schemas/flare-data-xml-schema';
import { CustomAttributesSchemaPlugin } from '@common/flare/schema/custom-attributes-schema-plugin';
import { TextSchemaPlugin } from '@common/flare/schema/text-schema.plugin';
import { SimpleDomDocument } from '@common/html/simple-dom/node';
import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';

export class TocSchema extends FlareDataXmlSchema {

  get name(): string { return 'toc'; }
  get version(): string { return '0.1.0'; }

  constructor(createGuid?: () => string) {
    const schemaPlugins: SchemaPlugin[] = [
      new TocSchemaPlugin(), // all nodes should be configured as block-type nodes to be compatible with comments and unknown nodes
      new TextSchemaPlugin(), // add 'text' node due to prosemirror requirements
      new FlareDataCommentSchemaPlugin(), // add 'comment' as block-type node to support xml comments in the ToC document
      new FlareDataUnknownSchemaPlugin(), // add unknown tags as block-type nodes that are not managed by the ToC editor to allow them in the ToC document
      new CustomAttributesSchemaPlugin(), // support custom attributes in the ToC document
    ];

    super(schemaPlugins, createGuid);
  }

  public validateXmlDoc(xmlDoc: SimpleDomDocument): void {
    this.validateRootElement(xmlDoc, TocXmlNodeName.Toc);
  }

}
